export default {
  name: 'clock',
  type: 'layout',
  active: false,
  data: {}
}
